import { keyframes } from '../utils/keyframes';

/**
 * Reusable keyframe animations
 * Can be used with CSS animation property
 */

// Fade animations
export const fadeIn = keyframes({
  '0%': { opacity: 0 },
  '100%': { opacity: 1 },
});

export const fadeOut = keyframes({
  '0%': { opacity: 1 },
  '100%': { opacity: 0 },
});

// Slide animations
export const slideInUp = keyframes({
  '0%': { opacity: 0, transform: 'translateY(20px)' },
  '100%': { opacity: 1, transform: 'translateY(0)' },
});

export const slideInDown = keyframes({
  '0%': { opacity: 0, transform: 'translateY(-20px)' },
  '100%': { opacity: 1, transform: 'translateY(0)' },
});

export const slideInLeft = keyframes({
  '0%': { opacity: 0, transform: 'translateX(-20px)' },
  '100%': { opacity: 1, transform: 'translateX(0)' },
});

export const slideInRight = keyframes({
  '0%': { opacity: 0, transform: 'translateX(20px)' },
  '100%': { opacity: 1, transform: 'translateX(0)' },
});

// Scale animations
export const scaleIn = keyframes({
  '0%': { opacity: 0, transform: 'scale(0.9)' },
  '100%': { opacity: 1, transform: 'scale(1)' },
});

export const scaleOut = keyframes({
  '0%': { opacity: 1, transform: 'scale(1)' },
  '100%': { opacity: 0, transform: 'scale(0.9)' },
});

export const zoomIn = keyframes({
  '0%': { opacity: 0, transform: 'scale(0)' },
  '100%': { opacity: 1, transform: 'scale(1)' },
});

// Rotate animations
export const rotateIn = keyframes({
  '0%': { opacity: 0, transform: 'rotate(-90deg)' },
  '100%': { opacity: 1, transform: 'rotate(0)' },
});

export const spin = keyframes({
  '0%': { transform: 'rotate(0deg)' },
  '100%': { transform: 'rotate(360deg)' },
});

// Attention animations
export const pulse = keyframes({
  '0%, 100%': { transform: 'scale(1)' },
  '50%': { transform: 'scale(1.05)' },
});

export const shake = keyframes({
  '0%, 100%': { transform: 'translateX(0)' },
  '10%, 30%, 50%, 70%, 90%': { transform: 'translateX(-5px)' },
  '20%, 40%, 60%, 80%': { transform: 'translateX(5px)' },
});

export const bounce = keyframes({
  '0%, 20%, 50%, 80%, 100%': { transform: 'translateY(0)' },
  '40%': { transform: 'translateY(-20px)' },
  '60%': { transform: 'translateY(-10px)' },
});

export const wiggle = keyframes({
  '0%, 100%': { transform: 'rotate(0deg)' },
  '25%': { transform: 'rotate(10deg)' },
  '50%': { transform: 'rotate(0deg)' },
  '75%': { transform: 'rotate(-10deg)' },
});

export const heartbeat = keyframes({
  '0%': { transform: 'scale(1)' },
  '14%': { transform: 'scale(1.15)' },
  '28%': { transform: 'scale(1)' },
  '42%': { transform: 'scale(1.15)' },
  '70%': { transform: 'scale(1)' },
});

export const flash = keyframes({
  '0%, 50%, 100%': { opacity: 1 },
  '25%, 75%': { opacity: 0 },
});

// Loading animations
export const shimmer = keyframes({
  '0%': { backgroundPosition: '-200% 0' },
  '100%': { backgroundPosition: '200% 0' },
});

export const pulseDot = keyframes({
  '0%, 80%, 100%': { transform: 'scale(0)' },
  '40%': { transform: 'scale(1)' },
});

export const ripple = keyframes({
  '0%': { transform: 'scale(0)', opacity: 1 },
  '100%': { transform: 'scale(4)', opacity: 0 },
});

// Float animation
export const float = keyframes({
  '0%, 100%': { transform: 'translateY(0)' },
  '50%': { transform: 'translateY(-10px)' },
});

// Glow animation
export const glow = keyframes({
  '0%, 100%': { boxShadow: '0 0 5px currentColor' },
  '50%': { boxShadow: '0 0 20px currentColor, 0 0 30px currentColor' },
});

export const allKeyframes = {
  fadeIn,
  fadeOut,
  slideInUp,
  slideInDown,
  slideInLeft,
  slideInRight,
  scaleIn,
  scaleOut,
  zoomIn,
  rotateIn,
  spin,
  pulse,
  shake,
  bounce,
  wiggle,
  heartbeat,
  flash,
  shimmer,
  pulseDot,
  ripple,
  float,
  glow,
} as const;

export type KeyframeName = keyof typeof allKeyframes;
